import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Hooks
import { useMeetingModeTracking } from 'Shared/tracking/use-meeting-mode-tracking';

// Selectors
import { getUserFlag } from 'Shared/selectors/user';

// Utils
import { getCurrentMoment, convertMomentToUnix } from 'Shared/utils/DateTime.utils';

// Actions
import * as UsersActions from 'Shared/actions/Users.actions';

// Components
import WelcomeBackMeetingModeIntro from './WelcomeBackMeetingModeIntro/WelcomeBackMeetingModeIntro';
import FirstTimeMeetingModeIntro from './FirstTimeMeetingModeIntro/FirstTimeMeetingModeIntro';

const MeetingModeIntroModal = () => {
  const dispatch = useDispatch();
  const { trackSawStartScreen } = useMeetingModeTracking();
  const [hasSeenV2] = useState(Boolean(useSelector(state => getUserFlag(state, { flag: 'seen_v2_meeting_mode' }))));

  const hasSeenOldWorkspaceMeetingMode = useSelector(state => state.user.hasSeenDiscussionRoom);

  useEffect(() => {
    if (!hasSeenV2) {
      const timestamp = convertMomentToUnix(getCurrentMoment());
      dispatch(UsersActions.updateUserFlag('seen_v2_meeting_mode', timestamp));
      trackSawStartScreen({ isFirstTimeUser: !hasSeenOldWorkspaceMeetingMode });
    }
  }, []);

  if (hasSeenV2) return null;
  if (hasSeenOldWorkspaceMeetingMode && !hasSeenV2) return <WelcomeBackMeetingModeIntro />;
  if (!hasSeenOldWorkspaceMeetingMode && !hasSeenV2) return <FirstTimeMeetingModeIntro />;
  return null;
};

export default MeetingModeIntroModal;
